import CurrentUserProvider from "@/providers/CurrentUserProvider"
import React from "react"
import AdminWeeklyCalendar from "./Calendar"

const AdminWeeklyCalendarPage = () => {
  return (
    <CurrentUserProvider>
      <AdminWeeklyCalendar />
    </CurrentUserProvider>
  )
}

export default AdminWeeklyCalendarPage
